<!--			 	-->
<!-- Visitor Detail -->
<!-- 			 	-->
<div [style.display]="VisitorLogID > 0 ? 'block' : 'none'">
	<!-- 	   -->
	<!-- Title -->
	<!-- 	   -->
	<div class="PersonTitle-main">
		<!-- 				   -->
		<!-- Display When Busy -->
		<!-- 				   -->
		<div style="margin-right: 10px" [style.display]="isBusy == true ? 'block' : 'none'">
			<label style="width: 24px"></label>
			<!-- Used to keep 'Visitor Pass Detail' text from shifting when busy/ not busy -->
		</div>

		<div>
			<label class="PersonTitleText-main">Visitor Pass Detail</label>
		</div>

		<!-- 				   -->
		<!-- Display When Busy -->
		<!-- 				   -->
		<div style="margin-left: 10px" [style.display]="isBusy == true ? 'block' : 'none'">
			<img class="busy-img" src="assets/images/loading.gif" />
		</div>
	</div>

	<!-- 					  -->
	<!-- Display Person Data -->
	<!-- 					  -->
	<div class="PersonData-main">
		<div class="PersonData-col">
			<!-- COL1 -->
			<div>
				<table>
					<tr>
						<td class="PersonData-title-tab">Visitor Name:</td>
						<td class="PersonData-data-tab">{{ FirstName }} {{ LastName }}</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Barcode:</td>
						<td class="PersonData-data-tab">{{ Barcode }}</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Require Escort:</td>
						<td class="PersonData-data-tab">
							{{ RequiresEscort ? "Yes" : "No" }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Log Date/Time:</td>
						<td class="PersonData-data-tab">
							{{ LogDT | date : "M/d/yyyy h:mm a" }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Visitor Log Status:</td>
						<td class="PersonData-data-tab">
							{{ VisitorLogStatusDesc }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Entry Location:</td>
						<td class="PersonData-data-tab">
							{{ EntryFacilityLocation }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Visit Duration:</td>
						<td class="PersonData-data-tab">
							{{ strDurationMin }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Destination Location:</td>
						<td class="PersonData-data-tab">
							{{ DestinationFacilityLocation }}
						</td>
					</tr>
					<tr>
						<td class="PersonData-title-tab">Comment:</td>
						<td class="PersonData-data-tab">{{ Comment }}</td>
					</tr>
				</table>
			</div>
		</div>
	</div>

	<!-- 					   -->
	<!-- Display Person Images -->
	<!-- 					   -->
	<div class="PersonImage-main">
		<div class="PersonData-col">
			<!-- COL1 -->
			<div>
				<table>
					<tr>
						<td class="PersonImage-title-tab">Photo</td>
					</tr>
					<tr>
						<div class="image-view">
							<div [style.display]="Person_Image.length >= 10 ? 'block' : 'none'">
								<img class="image-view-img" [src]="Person_Image" />
							</div>
							<div [style.display]="Person_Image.length < 10 ? 'block' : 'none'">
								<label>No Image</label>
							</div>
						</div>
					</tr>

					<tr style="height: 20px"></tr>
					<!-- Do This, Margins dont work in a <tr> -->

					<tr>
						<td class="PersonImage-title-tab">Presented ID</td>
					</tr>
					<tr>
						<div class="image-view">
							<div [style.display]="Primary_PresentedIDCardScan_Image.length >= 10 ? 'block' : 'none'">
								<img class="image-view-img" [src]="Primary_PresentedIDCardScan_Image" />
							</div>
							<div [style.display]="Primary_PresentedIDCardScan_Image.length < 10 ? 'block' : 'none'">
								<label>No Image</label>
							</div>
						</div>
					</tr>
				</table>
			</div>

			<!-- COL2 -->
			<div>
				<table style="margin-left: 25px">
					<tr>
						<td class="PersonImage-title-tab">Signature</td>
					</tr>
					<tr>
						<div class="image-view">
							<div [style.display]="CapturedSignature_Image.length >= 10 ? 'block' : 'none'">
								<img class="image-view-img" [src]="CapturedSignature_Image" />
							</div>
							<div [style.display]="CapturedSignature_Image.length < 10 ? 'block' : 'none'">
								<label>No Image</label>
							</div>
						</div>
					</tr>

					<tr style="height: 20px"></tr>
					<!-- Do this, Margins dont work in a <tr> -->

					<tr>
						<td class="PersonImage-title-tab">Presented ID (Secondary)</td>
					</tr>
					<tr>
						<div class="image-view">
							<div [style.display]="Secondary_PresentedIDCardScan_Image.length >= 10 ? 'block' : 'none'">
								<img class="image-view-img" [src]="Secondary_PresentedIDCardScan_Image" />
							</div>
							<div [style.display]="Secondary_PresentedIDCardScan_Image.length < 10 ? 'block' : 'none'">
								<label>No Image</label>
							</div>
						</div>
					</tr>
				</table>
			</div>
		</div>
	</div>
</div>
